app.filter('isSet', [
    function() {
        return function(input, customString) {
            return (input ? input : (customString ? customString : 'T.DATA.NOT_SET'));
        };
    }
]);